/**
 * Exportar tudo.
 *
 * ADR-0006: os dados sao da familia, nao nossos. Tem de haver sempre uma forma
 * de os levar embora sem pedir licenca a ninguem e sem precisar de internet.
 *
 * O arquivo sai em JSON legivel, com uma tabela por entidade, mais o trilho de
 * auditoria e as configuracoes. Deliberadamente inclui o historico: sem ele, a
 * copia nao permite reconstruir o que aconteceu.
 */
import type { FlosCore } from '@flos/core';

export interface ExportBundle {
  formato: 'flos-export';
  versao: 1;
  geradoEm: string;
  familia: string | null;
  entidades: Record<string, unknown[]>;
  auditoria: unknown[];
  configuracoes: unknown[];
}

export async function buildExportBundle(core: FlosCore): Promise<ExportBundle> {
  const entidades: Record<string, unknown[]> = {};
  for (const entity of core.registry.allEntities()) {
    try {
      entidades[entity.name] = await core.db.records(entity.name).toArray();
    } catch {
      // Uma tabela em falta (plugin desligado depois de escrever) nao pode
      // impedir a exportacao do resto.
      entidades[entity.name] = [];
    }
  }

  return {
    formato: 'flos-export',
    versao: 1,
    geradoEm: new Date().toISOString(),
    familia: core.session.peek()?.familyId ?? null,
    entidades,
    auditoria: await core.db.audit.toArray(),
    configuracoes: await core.db.settingsTable.toArray(),
  };
}

/** Constroi o pacote e oferece-o como arquivo. Sem rede nenhuma pelo meio. */
export async function exportAllData(core: FlosCore): Promise<ExportBundle> {
  const bundle = await buildExportBundle(core);
  if (typeof document === 'undefined' || typeof URL.createObjectURL !== 'function') {
    return bundle;
  }

  const blob = new Blob([JSON.stringify(bundle, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `vida-em-familia-${new Date().toISOString().slice(0, 10)}.json`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
  return bundle;
}
